<div class="mt-24">
  <div class="filter">
    <div class="panel">
      <div class="panel__content">
        <!-- Панель фильтра -->
        <div class="grid">
          <div class="grid__box grid__box--size-3">
            <div class="text-title mb-8">Регион</div>
            <div class="field field--select">
              <app-select [items]="regions" [initBy]="selectedRegion" [textKey]="'name'" [defaultText]="'Выберите регион'" (callback)="onChangeRegion($event)"></app-select>
            </div>
          </div>
          <div class="grid__box grid__box--size-3">
            <div class="text-title mb-8">Филиал</div>
            <div class="field field--select">
              <app-select
                [items]="branches"
                [initBy]="selectedBranch"
                [textKey]="'mb_name'"
                [defaultText]="selectedRegion ? 'Выберите филиал' : 'Выберите регион'"
                [isDisabled]="branches.length === 0"
                (callback)="onChangeBranch($event)"
              ></app-select>
            </div>
          </div>
          <div class="grid__box grid__box--size-3">
            <div class="text-title mb-8">Участок</div>
            <div class="field field--select">
              <app-select
                [items]="sectors"
                [initBy]="selectedSector"
                [textKey]="'sector_number_str'"
                [defaultText]="!selectedRegion ? 'Выберите регион' : !selectedBranch ? 'Выберите филиал' : 'Выберите участок'"
                [isDisabled]="sectors.length === 0"
                (callback)="onChangeSector($event)"
              ></app-select>
            </div>
          </div>
          <div class="align-end grid__box grid__box--size-min">
            <div class="grid grid--va-middle">
              <div class="grid__box grid__box--size-min">
                <button type="button" class="button button--primary" (click)="applyFilter()">Применить</button>
              </div>
              <div class="grid__box grid__box--size-min">
                <a id="appResetCompanyFilter" class="link link--dotted-blue-dark" (click)="resetFilter()">Сбросить</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="isFilterApplied">
  <!-- Таблица выбранного сектора (если есть) -->
  <ng-container *ngIf="appliedSector">
    <div class="normatives-table-section">
      <h2 class="title title--big mt-32">Участок {{ appliedSector.sector_number_str }}</h2>
      <app-normative-table [headers]="sectorTableHeaders" [rows]="sectorTableRows" [level]="'sector'" (overwrite)="handleOverwrite($event)"></app-normative-table>
      <div class="mt-32 pagination__block text-center" *ngIf="sectorHasMoreData && sectorTableRows.length > 0">
        <button *ngIf="false" type="button" class="button pagination__block-button" (click)="loadMoreSectorStandards()">Показать еще записи</button>
      </div>
    </div>
  </ng-container>

  <!-- Таблица выбранного филиала (если есть) -->
  <ng-container *ngIf="appliedBranch">
    <div class="normatives-table-section">
      <h2 class="title title--big mt-32">{{ appliedBranch.mb_name }}</h2>
      <app-normative-table [headers]="branchTableHeaders" [rows]="branchTableRows" [level]="'region'" (overwrite)="handleOverwrite($event)"></app-normative-table>
      <div class="mt-32 pagination__block text-center" *ngIf="branchHasMoreData && branchTableRows.length > 0">
        <button *ngIf="false" type="button" class="button pagination__block-button" (click)="loadMoreBranchStandards()">Показать еще записи</button>
      </div>
    </div>
  </ng-container>

  <!-- Таблица выбранного региона (если есть) -->
  <ng-container *ngIf="appliedRegion">
    <div class="normatives-table-section">
      <h2 class="title title--big mt-32">{{ appliedRegion.name }}</h2>
      <app-normative-table [headers]="federalTableHeaders" [rows]="federalTableRows" [level]="'federal'" (overwrite)="handleOverwrite($event)"></app-normative-table>
      <div class="mt-32 pagination__block text-center" *ngIf="federalHasMoreData && federalTableRows.length > 0">
        <button *ngIf="false" type="button" class="button pagination__block-button" (click)="loadMoreFederalStandards()">Показать еще записи</button>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-container>
  <div class="normatives-table-section">
    <h2 class="title title--big mt-32">Российская Федерация</h2>
    <app-normative-table [headers]="rfTableHeaders" [rows]="rfTableRows" [level]="'country'" (overwrite)="handleOverwrite($event)"></app-normative-table>
    <div class="mt-32 pagination__block text-center" *ngIf="rfHasMoreData && rfTableRows.length > 0">
      <button *ngIf="false" type="button" class="button pagination__block-button" (click)="loadMoreRfStandards()">Показать еще записи</button>
    </div>
  </div>
</ng-container>

<div *ngIf="isLoading" class="loader-container">
  <app-loader></app-loader>
</div>
